var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17C24.5 18 22.75 23.25 17.25 23.25C11.75 23.25 10 18 10 17C10 16 11.75 10.75 17.25 10.75C22.75 10.75 24.5 16 24.5 17Z",
    stroke: "#535862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 19.25C18.4926 19.25 19.5 18.2426 19.5 17C19.5 15.7574 18.4926 14.75 17.25 14.75C16.0074 14.75 15 15.7574 15 17C15 18.2426 16.0074 19.25 17.25 19.25Z",
    stroke: "#535862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.0b7bedb3bbe8b9ba31f201cfc1e75faa.svg";
export { ForwardRef as ReactComponent };